import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, Row, Typography } from "antd";
import { useFlow, FLOWS } from "hook/clients/kyc/useFlow";
import { useStep } from "hook/clients/kyc/useStep";
import KycDocLegal from "./component/kyc_doc_legal";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const LayoutDoc = () => {
  // -------------------------- VAR -----------------------------
  const form = Form?.useFormInstance();
  const { flow } = useFlow();
  const { handlePrev, handleComplete } = useStep();
  const isFlow = flow === FLOWS.DOC;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Row gutter={[20, 0]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        <Typography.Title level={2}>
          Tài liệu pháp lý liên quan
        </Typography.Title>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        <Typography.Paragraph style={{ fontSize: 16 }}>
          <p>Các giấy tờ sau đây được coi là hợp lệ</p>
          <ul>
            <li>
              Giấy chứng nhận đăng ký doanh nghiệp (Certificate of
              Incorporation).
            </li>
            <li>Điều lệ công ty (Articles of Association).</li>{" "}
            <li>
              Giấy tờ chứng minh địa chỉ doanh nghiệp (ví dụ: hóa đơn điện,
              nước).
            </li>{" "}
            <li>
              Giấy phép kinh doanh (nếu thuộc ngành có điều kiện như tài chính,
              y tế).
            </li>
            <li>
              Hợp đồng dịch vụ/Chính sách hoàn tiền (đối với một số ngành).
            </li>
          </ul>
        </Typography.Paragraph>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        <KycDocLegal />
      </Col>
      <Divider />
      <Col xl={12} lg={12} md={12} xs={12}>
        {/* <Button
          onClick={handlePrev}
          style={{ borderRadius: 5 }}
          icon={<LeftOutlined />}
          size="large"
        >
          Quay lại
        </Button> */}
      </Col>
      <Col align="right" xl={12} lg={12} md={12} xs={12}>
        <Button
          onClick={() => handleComplete(form)}
          type="primary"
          style={{ borderRadius: 5 }}
          icon={<RightOutlined />}
          iconPosition="end"
          size="large"
        >
          Gửi hồ sơ
        </Button>
      </Col>
    </Row>
  );
};
export default LayoutDoc;
